// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"569":"2a6527d1","741":"63ec2741"}[chunkId] + ".chunk.js";
};